(function () {
  var STORAGE_KEY = 'bhi:recently_viewed';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function readHandles() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function fetchCard(handle) {
    return fetch('/products/' + handle + '?section_id=bhi-product-card')
      .then(function (response) {
        if (!response.ok) return '';
        return response.text();
      })
      .then(function (html) {
        if (!html) return null;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        return wrapper.querySelector('.grid__item');
      })
      .catch(function () {
        return null;
      });
  }

  function renderSection(section) {
    var grid = section.querySelector('[data-bhi-recently-viewed-grid]');
    if (!grid) return;
    var current = section.getAttribute('data-product-handle');
    var handles = readHandles().filter(function (handle) {
      return handle && handle !== current;
    });
    var max = parseInt(section.getAttribute('data-max') || '6', 10);
    handles = handles.slice(0, max);

    if (handles.length === 0) {
      section.classList.add('bhi-hide');
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetchCard(handle);
      })
    ).then(function (cards) {
      cards.forEach(function (card) {
        if (!card) return;
        grid.appendChild(card);
      });
    });
  }

  onReady(function () {
    document.querySelectorAll('[data-bhi-recently-viewed]').forEach(function (section) {
      renderSection(section);
    });
  });
})();
